@if (notFound$ | async) {
  <div class="error">
    <img src="/portal/assets/not-found.png" alt="System not found" />
    <sh-text size="title-1">Looks like something is wrong!</sh-text>
    <sh-text size="body-1">
      This combination of material number and<br />
      serial number is not known.
    </sh-text>
  </div>
} @else {
  <div class="layout">
    <app-system-details
      *ngIf="(routeService.hideSystemDetails$ | async) !== true"
      [systemDetails]="
        (systemOverviewService.systemDetails.data$ | async) || undefined
      "
    ></app-system-details>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
}
